import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import OtpModal from "../Modals/OtpModal";
import "./PasswordRecovery.css";

const PasswordRecovery = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [otpModalVisible, setOtpModalVisible] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage("");
    
    try {
      const encodedEmail = encodeURIComponent(email);

      const res = await axios.get(`/user/forgot-password/${encodedEmail}`);
      if (!res.data.successStatus) {
        setIsSubmitting(false);
        setErrorMessage(res.data.message || "Error sending OTP");
        return;
      }
      setOtpModalVisible(true);
    } catch (err) {
      setErrorMessage(
        err?.response?.data?.message || "Failed to send OTP, try again.",
      );
      // console.log(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOtpVerify = (code) => {
    setOtpModalVisible(false);
    navigate("/set-new-password", {
      state: { email, code },
    });
  };

  const handleResendOtp = async () => {
    try {
      const encodedEmail = encodeURIComponent(email);

      const res = await axios.get(`/user/forgot-password/${encodedEmail}`);

      return res.data.successStatus;
    } catch {
      return false;
    }
  };

  return (
    <div className="recovery-container">
      <div className="content-wrapper-password-recovery">
        <div className="logo">NIMBLEBASH</div>

        <div className="form-content">
          <h1>Password Recovery</h1>
          <p className="instructions">
            Provide your registered email. An OTP will be sent for password
            recovery verification.
          </p>

          {errorMessage && (
            <p className="error-text" style={{ color: "red" }}>
              {errorMessage}
            </p>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="linda@nimblebash.com"
                required
              />
            </div>

            <div className="buttons-container">
              <button
                type="button"
                className="back-btn"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
              <button
                type="submit"
                className="proceed-btn"
                disabled={isSubmitting || !email}
              >
                {isSubmitting ? "Processing..." : "Proceed"}
              </button>
            </div>
          </form>
        </div>
      </div>

      <OtpModal
        visible={otpModalVisible}
        email={email}
        onClose={() => setOtpModalVisible(false)}
        onVerify={handleOtpVerify}
        onResend={handleResendOtp}
        title="Enter OTP"
        description="We've sent a One-Time Password (OTP) to your email. Enter it below to reset your password."
        verifyButtonText="Verify OTP"
      />
    </div>
  );
};

export default PasswordRecovery;
